import React from 'react';
import BoletosSearch from './search';
import ButtonOptions from '../../../../../components/NovoSistema/ButtonOptions';
import HeaderButtons from '../../../../../components/NovoSistema/HeaderButtons';

export default function Boletos() {
  return (
    <main>
      <HeaderButtons>
        <ButtonOptions buttonName="Emitir Boleto" border="#333F50" />
        <ButtonOptions buttonName="Emitir e Enviar E-mail" border="#333F50" />
        <ButtonOptions buttonName="Reimprimir" border="#333F50" />
        <ButtonOptions buttonName="Enviar/Reenviar por E-mail" border="#333F50" />
        <ButtonOptions buttonName="Gerar Remessa" border="#333F50" />
        <ButtonOptions buttonName="Alterar Situação Remessa" border="#333F50" />
        <ButtonOptions buttonName="Alterar Situação Boleto" border="#333F50" />
        <ButtonOptions buttonName="Cancelar Remessa" border="#333F50" disabled={true} />
      </HeaderButtons>
      <BoletosSearch />
    </main>
  );
}
